import { render, staticRenderFns } from "./RevenueShareFormBottomArea.vue?vue&type=template&id=caf621e2&scoped=true&"
import script from "./RevenueShareFormBottomArea.vue?vue&type=script&lang=js&"
export * from "./RevenueShareFormBottomArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf621e2",
  null
  
)

export default component.exports